import { AppState } from 'Store'

const getAll = (state: AppState) => state.modules.notificationPopup.notifications
const getAllView = (state: AppState) =>
	state.modules.notificationPopup.notifications.filter((notify) => notify.view)

export const notificationPopupSelector = {
	getAll,
	getAllView,
}
